export const userFeedbackReportSelector = state => (state.administration.reports.userFeedbackReport.data.userFeedbackViewModels.pagedCollection);
export const userFeedbackReportTotalPages = state => (state.administration.reports.userFeedbackReport.data.userFeedbackViewModels.totalPages);
